import { Box, useTheme } from '@mui/material'
import { BasePageContainerProps, BaseHeader } from './BasePageContainer'

export const DesktopPageContainer = ({ children, title, subtitle, headerAction }: BasePageContainerProps) => {
    const theme = useTheme()
    return (
        <Box
            sx={{
                p: 3,
                width: '100%',
                maxWidth: '100vw',
                overflow: 'hidden',
                bgcolor: '#1a1a1a',
                minHeight: '100vh',
                color: 'white',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                marginLeft: theme.spacing(2),
            }}
        >
            <BaseHeader title={title} subtitle={subtitle} headerAction={headerAction} />
            {children}
        </Box>
    )
} 